import { AsyncSelect, type IAsyncSelectProps } from '@procurify/ui'

import { UserAPI } from '@webapp/api/UserAPI'
import { useProcurifyIntl } from '@webapp/hooks'
import { type User } from '@webapp/models'
import { type PermissionEnum } from '@webapp/platform/iam'
import { getFullName } from '@webapp/utils/user'
import messages from './messages'
import { UserSelectStyled } from './styles/UserSelectStyled'

export interface IUserSelectProps<IsMulti extends boolean = false>
  extends IAsyncSelectProps<User, IsMulti> {
  placeholder?: string
  permissions?: PermissionEnum[]
}

export const UserSelect = <IsMulti extends boolean = false>({
  placeholder,
  permissions = [],
  cacheOptions = true,
  ...otherProps
}: IUserSelectProps<IsMulti>) => {
  const intl = useProcurifyIntl()

  const loadOptions = (inputValue, pagination, callback) => {
    const params = {
      ...(inputValue && { search: inputValue }),
      is_active: 'True',
      permission: permissions.join('|'),
      page: pagination.page,
      order_by: 'firstName',
    }

    UserAPI.getBasicList(params)
      .then((res) => {
        callback({
          options: res.data,
          pagination: {
            hasMore: !!res.metadata.pagination.next,
            page: pagination.page + 1,
          },
        })
      })
      .catch(() => null)
  }
  return (
    <UserSelectStyled>
      <AsyncSelect
        cacheOptions={cacheOptions}
        getOptionLabel={(option) => getFullName(option)}
        getOptionValue={(option) => option.id.toString()}
        loadOptions={loadOptions}
        placeholder={
          placeholder || intl.formatMessage(messages.placeholderText)
        }
        {...otherProps}
      />
    </UserSelectStyled>
  )
}

UserSelect.displayName = 'UserSelect'
